import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { App } from './App.js';
import { queryClient } from './lib/query-client.js';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

// Served by the API under /app (src/console/index.ts); the router lives there too.
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/app">
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
